module.exports = __webpack_public_path__ + "img/descending.40b9c596.svg";